import { supabase } from "@/lib/supabase-client";

export const callRequestService = {
  async submitCallRequest(
    callRequestData: Record<string, any>,
    source: "web" | "mobile" = "web",
  ): Promise<{ success: boolean; incident_id?: string; error?: string }> {
    const { data, error } = await supabase.rpc("submit_call_request", {
      p_call_request_data: callRequestData,
      p_source: source,
    });

    if (error) {
      return { success: false, error: error.message };
    }

    return data as { success: boolean; incident_id?: string; error?: string };
  },
};
